export enum LocationArea {
  honolulu = 'Honolulu',
  northshore = 'North Shore',
  kailua = 'Kailua',
}

export interface LocationEntry {
  location: string;
  note?: string;
  href?: string;
  area: LocationArea[];
}

export interface LocationTopic {
  topic: string;
  entries: LocationEntry[];
}

export const locations: LocationTopic[] = [
  {
    topic: 'Eat & Drink',
    entries: [
      {
        location: 'Bevy',
        note:
          "Located in Kaka'ako SALT, Bevy is a market during the day with tasty sandwiches and local treats. \
          At night it turns into a bar serving craft cocktails and oysters. There's also a sweet happy hour deal!",
        href: 'https://www.bevyhawaii.com',
        area: [LocationArea.honolulu],
      },
      {
        location: 'Arvo',
        note:
          "Aussie-owned coffee spot in Kaka'ako SALT serving some kick-ass coffee and all the avocado toast \
          you could ever want. Hop next door to the best little floral shop, Paiko, and pick out an air plant to \
          remember your visit!",
        href: 'https://www.instagram.com/A_R_V_O/',
        area: [LocationArea.honolulu],
      },
      {
        location: 'Encore Saloon',
        note:
          'Order all the tacos and then get a Chris Katan to wash them all down. Authentic street taco flavors \
          and all the tequila you can drink. Our favorite place in Chinatown.',
        href: 'http://www.encoresaloon.com',
        area: [LocationArea.honolulu],
      },
      {
        location: 'Kahuku Farms',
        note:
          'An honest to goodness farm on the Northshore. Take a tour and end with lunch in the cafe. \
          The grilled banana bread might be the best thing ever.',
        href: 'https://www.kahukufarms.com',
        area: [LocationArea.northshore],
      },
      {
        location: "Sunset Beach / Shark's Cove Food Trucks",
        note:
          "Just past Pipeline and across the street from Shark's Cove on the Northshore, this is our favorite spot \
        to grab lunch after early morning snorkeling. Perfect for picky eaters who can never decide what they want,\
        there is something for everyone. Take your cue from the name and come at sunset when the views are even better \
        than the fish tacos!",
        area: [LocationArea.northshore],
      },
      {
        location: 'Kalapawai Cafe',
        note:
          'If you make it over to our side of the island, this is the best spot in Kailua for a glass of wine \
        and the fresh fish special. Also try the wild mushroom gnocchi.',
        href: 'http://www.kalapawaimarket.com/section/cafe/',
        area: [LocationArea.kailua],
      },
      {
        location: 'Steak Rave',
        note:
          "If you've visited us here, there’s a chance we've fed you Steak Noodles from Steak Rave. \
        Although you'd never think to order steak from inside a liquor store, the food is fantastic and a \
        truly local experience. We also may know the owner by name….",
        href: 'https://www.yelp.com/biz/oneawa-market-kailua',
        area: [LocationArea.kailua],
      },
      {
        location: 'Nalu',
        note:
          "Acai bowl lovers, you'll be happy to know there are locations in Kailua and Honolulu! \
        Try any of their juices or the Ahi tuna wrap (it's my fav!) Matt thinks this is the best acai bowl on the \
        island.",
        href: 'http://naluhealthbar.com',
        area: [LocationArea.kailua, LocationArea.honolulu],
      },
      {
        location: "Boston's Pizza",
        note:
          "New York style pizza didn't make it across the Pacific, but Boston style Pizza did? Still can't figure \
        this one out, but it's the best pizza on the island. Slices the size of your face.",
        href: 'http://www.bostonpizzahi.com',
        area: [LocationArea.kailua, LocationArea.honolulu],
      },
      {
        location: 'The Pig & The Lady',
        note:
          'Go for the Spanish toasts, stay for the Kurobuta pork chops. Lunch or dinner, this Chinatown spot \
        has some of the best eats ever. Local with a twist.',
        href: 'http://thepigandthelady.com',
        area: [LocationArea.honolulu],
      },
      {
        location: 'Mud Hen Water',
        note:
          'Local food upgraded. Ask about everything on the menu and try as much as you can. The smoke meat \
        carbonara is insane. Drink the BMOC or any of the kitchen cocktails.',
        href: 'http://www.mudhenwater.com',
        area: [LocationArea.honolulu],
      },
      {
        location: 'Liliha Bakery',
        note: "Order a cream puff and a coffee, or try a malasada. It's impossible to eat just one!",
        href: 'http://www.lilihabakery.com',
        area: [LocationArea.honolulu],
      },
      {
        location: 'Beet Box Cafe',
        note: 'Vegetarian and still delicious! Located on the Northshore in Haleiwa.',
        href: 'https://www.thebeetboxcafe.com',
        area: [LocationArea.northshore],
      },
      {
        location: 'Sprout Sandwich Shop',
        note:
          "Right down the road from Dillingham Ranch, and next door to Aloha Lemonade. Get the chicken salad \
        sandwich. You won't be sorry.",
        href: 'https://squareup.com/store/haleiwasprout/',
        area: [LocationArea.northshore],
      },
      {
        location: 'Island Snow',
        note: 'President Obama gets his shaved ice here! Try it with macadamia nut ice cream on the bottom!',
        href:
          'https://www.tripadvisor.com/Restaurant_Review-g60652-d1233681-Reviews-Island_Snow-Kailua_Oahu_Hawaii.html',
        area: [LocationArea.kailua],
      },
    ],
  },
  {
    topic: 'Hikes',
    entries: [
      {
        location: 'Sunset Pillbox',
        note:
          "On the Northshore, this hike includes two pillboxes. Both are great to view the sunset from, \
        but bring shoes you don't mind getting dirty!",
        href: 'https://www.alltrails.com/trail/us/hawaii/ehukai-pillboxes',
        area: [LocationArea.northshore],
      },
      {
        location: 'Lulumaha Waterfall',
        note: 'A more advanced and adventurous hike, this one will take you to an impressive 50ft waterfall at the end',
        href: 'https://www.alltrails.com/trail/us/hawaii/lulumahu-falls-trail',
        area: [LocationArea.northshore],
      },
      {
        location: 'Manoa falls',
        note:
          'Located just outside Honolulu, this easy hike through the rainforest ends at a small \
        waterfall that you can swim in!',
        href: 'https://www.alltrails.com/trail/us/hawaii/manoa-falls-trail',
        area: [LocationArea.honolulu],
      },
      {
        location: 'Lanikai Pillbox',
        note:
          'These two pillboxes overlook the Mokes, the twin islands just off the shore in Kailua. \
          This hike is worth getting up early to watch the sunrise.',
        href: 'https://www.alltrails.com/trail/us/hawaii/kaiwa-ridge-pillbox-trail',
        area: [LocationArea.kailua],
      },
      {
        location: "Pu'u Ma'eli'eli Pillbox",
        note:
          'Located in Kaneohe, finding the start of this trail is the hardest part. \
          The end of the hike offers views of the entire bay and the reefs.',
        href: 'https://www.alltrails.com/trail/us/hawaii/puu-maelieli-trail',
        area: [LocationArea.kailua],
      },
      {
        location: 'Maunawili Falls',
        note:
          'This one will get muddy! However, the end of the hike is worth it with a fun \
          waterfall that you can jump off.',
        href: 'https://www.alltrails.com/trail/us/hawaii/maunawili-falls-trail',
        area: [LocationArea.kailua],
      },
      {
        location: 'Wiliwilinui Ridge',
        note:
          'This one is a longer hike that includes a number of stairs, so make sure you pack a snack. \
          At the end of the hike you can look out over all of Kailua and the Windward side of the island.',
        href: 'https://www.alltrails.com/trail/us/hawaii/wiliwilinui-ridge-trail',
        area: [LocationArea.honolulu],
      },
      {
        location: 'Diamond Head',
        note: 'If you do this hike on a weekend, you can enjoy the KCC farmers market when you come back down.',
        href: 'https://www.alltrails.com/trail/us/hawaii/diamond-head-leahi-summit-trail',
        area: [LocationArea.honolulu],
      },
      {
        location: 'KoKo Head',
        note:
          'Climb up to the top of the crater and look out over Hanauma Bay. This hike is not for those \
        with weak knees as it features a lot of stairs.',
        href: 'https://www.alltrails.com/trail/us/hawaii/koko-crater-trail',
        area: [LocationArea.honolulu],
      },
    ],
  },
  {
    topic: 'Swim',
    entries: [
      {
        location: 'Waimea Bay beach',
        note:
          "Northshore bucket list item. Huge waves in the winter but by May it's calmed down. If you're feeling \
        adventurous, jump off the rock!",
        area: [LocationArea.northshore],
      },
      {
        location: "Shark's Cove beach",
        note:
          'The best snorkeling on the Northshore. Get there early and swim with schools of zebra fish. \
        Across the street from parking and food trucks. Great sunset views!',
        area: [LocationArea.northshore],
      },
      {
        location: 'Banzai Pipeline beach',
        note:
          "Home to the biggest, baddest-ass waves on the island in the winter, it's float season in the summer. \
        Enjoy the beach and say you've paddled out at Pipe.",
        area: [LocationArea.northshore],
      },
      {
        location: 'Mermaid Caves',
        note:
          'Near Nanakuli Beach Park, these caves are only accessible during calm waters and low tides. \
        For the adventurous, this is one of the most beautiful and secluded spots on the island.',
        area: [LocationArea.northshore],
      },
      {
        location: 'Kailua Beach Park',
        note:
          'Our beaches, our side of the island. White sands, blue waters. \
        Paddle out to Flat Island or the Mokes and enjoy the views.',
        area: [LocationArea.kailua],
      },
      {
        location: 'Waikiki Beach',
        note:
          'The quintessential Hawaii experience. Fireworks every Friday night at sundown and hula dancers \
        on Tuesdays and Thursdays. Waikiki has some great beginner waves, so get those rental boards and paddle \
        out for a surf lesson!',
        area: [LocationArea.honolulu],
      },
      {
        location: 'Hanauma Bay',
        note: 'A great place for snorkeling. It can get crowded, so go early to see the best fish.',
        area: [LocationArea.honolulu],
      },
      {
        location: 'Electric Beach',
        note: 'If you get here early enough, you can swim with dolphins!',
        area: [LocationArea.honolulu],
      },
    ],
  },
  {
    topic: 'Explore',
    entries: [
      {
        location: 'Kualoa Ranch',
        note:
          'Get Jurassic with it and take a tour of movie sets, or atv through the valleys. \
        One of the most awe-inspiring views of the Kualoa Mountain Range.',
        href: 'http://www.kualoa.com',
        area: [LocationArea.kailua],
      },
      {
        location: 'Gunstock Ranch',
        note:
          "A Northshore ranch that makes you feel like you're a real Paniolo (Hawaiian cowboy). \
        The sweetheart ride includes a trail ride with lunch for two in a secluded spot with views \
        of the shore and mountains.",
        href: 'http://gunstockranch.com',
        area: [LocationArea.northshore],
      },
      {
        location: 'Old Town Haleiwa',
        note:
          'Shops, restaurants, and locals. Wander through this little surf town on the Northshore \
        and grab a SUP board for an afternoon adventure.',
        area: [LocationArea.northshore],
      },
      {
        location: 'Ala Moana mall',
        note:
          'Located in downtown Honolulu, this mall offers the most shopping on the island all in one spot. \
        Everything from Prada and Chanel to Old Navy and Nike can be found here.',
        area: [LocationArea.honolulu],
      },
      {
        location: 'Kailua',
        note:
          'Where we live! This little town is home for a reason. \
        Full of shops, restaurants, and right by the beach. Rent a bike and go exploring.',
        area: [LocationArea.kailua],
      },
      {
        location: 'Dole Plantation',
        note:
          'See how pineapples grow (so weird!) and take a train ride through the old plantation. \
        Walk through a pineapple maze, and try the Dole Whip once you make it out. Or you could just eat \
        the Dole Whip all day, honestly.',
        href: 'https://www.doleplantation.com',
        area: [LocationArea.northshore],
      },
      {
        location: 'International Marketplace',
        note: 'Has tons of restaurants, theaters, and shops. There is something for everyone here.',
        href: 'http://www.shopinternationalmarketplace.com',
        area: [LocationArea.honolulu],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data/location.ts